import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { fetchAllExpenseTags } from "~Shared/store/actions/expenseTag/expenseTagActions"
import { refetchExpenseTables } from "~Shared/store/actions/tables/tableActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToExpenseTag = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.DELETE) {
            dispatch(fetchAllExpenseTags())
            dispatch(refetchExpenseTables())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Expense Tag Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
